import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextInventory } from '../Inventory';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { StorageCenter } from '../../../../models/storage.center.model';

export interface StorageCenterPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  storageCentersForCompany: StorageCenter[] | null,
  loadStorageCentersForCompany: Function
};

const StorageCenterPage: React.FunctionComponent<StorageCenterPageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, storageCentersForCompany, loadStorageCentersForCompany} = UseOutletContextInventory()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, storageCentersForCompany, loadStorageCentersForCompany}}></Outlet>
  );
}

export function UseOutletContextStorageCenter() {
  return useOutletContext<ContexType>()
};

export default StorageCenterPage;
